module.exports = __webpack_public_path__ + "img/N.af85dafc.svg";